import React, { FC } from 'react';
import CustomModal from 'components/custom-modal/CustomModal';
import { NavCloseIcon } from 'assets/icons';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';

interface BlockedInfoPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const BlockedInfoPopup: FC<BlockedInfoPopupProps> = ({ isOpen, onClose }) => {
  return (
    <CustomModal
      open={isOpen}
      closeModal={onClose}
      className="flex flex-col gap-6 p-6 md:w-[375px]"
      backgroundColor="bg-white">
      <NavCloseIcon className="absolute right-4 top-4 cursor-pointer" onClick={onClose} />
      <div
        className="mx-auto flex w-full grow flex-col items-center justify-center 
                     p-5 px-4 text-center sm:px-2.5">
        <MerchantOrTeamBlockedInfo className="p-0" />
      </div>
    </CustomModal>
  );
};

export default BlockedInfoPopup;
